import React from 'react';
import { useDispatch } from 'react-redux';

import SightingList from '../Lists/SightingList';

import { hideModal } from '../../actions/modal/modal';

const UserSightings = () => {

  const dispatch = useDispatch();

  return (
    <>
      <span className="modal__close" onClick={ () => dispatch(hideModal()) }>&times;</span>

      <h3 className="modal__header">Your Koala Sightings</h3>

      <SightingList retrieveOwnSightings />
    </>
  );

}

export default UserSightings;